/**
 * Deterministic RNG helpers. `rand()` is Math.random today, but kept as a
 * function so the whole game can be swapped to a seeded generator if we
 * ever need reproducible runs (replays, determinism testing).
 */
export const rand = () => Math.random();
export const randRange = (lo: number, hi: number) => lo + rand() * (hi - lo);
export const randInt = (lo: number, hi: number) => Math.floor(randRange(lo, hi + 1));
export const pick = <T>(arr: T[]): T => arr[Math.floor(rand() * arr.length)];

/**
 * Weighted pick. Items must have a numeric `weight` (or `rarity`). Pass the
 * key name to `weightKey`. Returns `null` if the list is empty or all zero.
 */
export function weightedPick<T>(arr: T[], weightKey: keyof T): T | null {
  if (arr.length === 0) return null;
  let total = 0;
  for (const item of arr) total += Number(item[weightKey]) || 0;
  if (total <= 0) return null;
  let r = rand() * total;
  for (const item of arr) {
    r -= Number(item[weightKey]) || 0;
    if (r <= 0) return item;
  }
  return arr[arr.length - 1];
}
